/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAngleRight: {
  name: 'angle-right';
  data: string;
} = {
  name: 'angle-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.293 5.293a1 1 0 0 1 1.414 0L15 10.586a2 2 0 0 1 0 2.828l-5.293 5.293a1 1 0 0 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
